import React from 'react';

const AvatarInitial = ({ displayName }) => {
  return (
    <span className="avatar-initial">
      {displayName.charAt(0).toUpperCase()}
    </span>
  );
};

export default AvatarInitial;